import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  EXTERNAL_LETTERS_LIST,
  EXTERNAL_LETTER_COMMENT_TEMPLATES,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE,
  EXTERNAL_LETTER_COMPLETE,
  EXTERNAL_LETTER_COMPLETE_EXECUTION,
  EXTERNAL_LETTER_CONFIRM_INFORMED,
  EXTERNAL_LETTER_DELETE,
  EXTERNAL_LETTER_ITEM,
  EXTERNAL_LETTER_PROVIDE_RESOLUTION,
  EXTERNAL_LETTER_REGISTER,
  EXTERNAL_LETTER_REQUIRE_UPDATE,
  EXTERNAL_LETTER_SEND_TO_INFORM,
} from '../constants/actionTypes'
import * as API from '../constants/api'

/*
 * Legacy /letter/* thunks are disabled because the current backend schema
 * does not expose their endpoints or DTOs.
export const letterCreate = createAsyncThunk(
  LETTER_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.LETTER}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.letterCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterDelete = createAsyncThunk(
  LETTER_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.LETTER}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.letterDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterIncomingList = createAsyncThunk(
  LETTER_INCOMING_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_INCOMING}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterIncomingList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterOutgoingList = createAsyncThunk(
  LETTER_OUTGOING_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_OUTGOING}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterOutgoingList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterStatus = createAsyncThunk(
  LETTER_STATUS,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_STATUS}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.letterStatus(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const letterPublicInfo = createAsyncThunk(
  LETTER_PUBLIC_INFO,
  async (params: PayloadCreatorParams<`${typeof API.LETTER_PUBLIC_INFO}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.letterPublicInfo(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)
*/

export const externalLettersList = createAsyncThunk(
  EXTERNAL_LETTERS_LIST,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_LIST}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLettersList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterRegister = createAsyncThunk(
  EXTERNAL_LETTER_REGISTER,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_REGISTER}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLetterRegister(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterItem = createAsyncThunk(
  EXTERNAL_LETTER_ITEM,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLetterItem(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterDelete = createAsyncThunk(
  EXTERNAL_LETTER_DELETE,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_LIST}{id}`, 'delete'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLetterDelete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterCommentTemplates = createAsyncThunk(
  EXTERNAL_LETTER_COMMENT_TEMPLATES,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`, 'get'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterCommentTemplates()
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterCommentTemplateCreate = createAsyncThunk(
  EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterCommentTemplateCreate(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterCommentTemplateDelete = createAsyncThunk(
  EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_COMMENT_TEMPLATE}{id}`, 'delete'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterCommentTemplateDelete(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterSendToInform = createAsyncThunk(
  EXTERNAL_LETTER_SEND_TO_INFORM,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_SEND_TO_INFORM}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterSendToInform(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterProvideResolution = createAsyncThunk(
  EXTERNAL_LETTER_PROVIDE_RESOLUTION,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_RESOLUTION}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLetterProvideResolution(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterConfirmInformed = createAsyncThunk(
  EXTERNAL_LETTER_CONFIRM_INFORMED,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_CONFIRM_INFORMED}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterConfirmInformed(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterCompleteExecution = createAsyncThunk(
  EXTERNAL_LETTER_COMPLETE_EXECUTION,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_COMPLETE_EXECUTION}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterCompleteExecution(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterRequireUpdate = createAsyncThunk(
  EXTERNAL_LETTER_REQUIRE_UPDATE,
  async (
    params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_REQUIRE_UPDATE}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.externalLetterRequireUpdate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const externalLetterComplete = createAsyncThunk(
  EXTERNAL_LETTER_COMPLETE,
  async (params: PayloadCreatorParams<`${typeof API.EXTERNAL_LETTERS_COMPLETE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.externalLetterComplete(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const letterIncomingListClear = createAction(`${LETTER_INCOMING_LIST}/clear`)
// export const letterOutgoingListClear = createAction(`${LETTER_OUTGOING_LIST}/clear`)

export const externalLettersListClear = createAction(`${EXTERNAL_LETTERS_LIST}/clear`)

export const externalLetterItemClear = createAction(`${EXTERNAL_LETTER_ITEM}/clear`)

export const externalLetterCommentTemplatesClear = createAction(`${EXTERNAL_LETTER_COMMENT_TEMPLATES}/clear`)
